<div class="event-line" [class.event-line--excluded]="excluded()">
	<mat-checkbox
		class="event-count-checkbox"
		[checked]="!excluded()"
		[disabled]="disabled()"
		(change)="onCountedChange($event.checked)"
		matTooltip="Czy liczyć ten wpis do rozliczenia"
		matTooltipPosition="above"
		aria-label="Liczyć do rozliczenia"
	></mat-checkbox>
	<a class="event-dates" routerLink="/settlements/settlementBonus/{{ bonusId() }}" target="_blank">
		{{ date() | date: 'yyyy-MM-dd' }}
		<span class="event-dash">·</span>
		{{ name() }}
	</a>
	<span class="event-amount" [class.event-amount--excluded]="excluded()">
		<strong>{{ amountGrosze() | priceCurrency: currency() || 'PLN' }}</strong>
		@if (isSettled() === '1') {
			<span class="settlement-badge settlement-badge-settled">Rozliczone</span>
		}
		@if (confirmAt()) {
			<span class="settlement-badge settlement-badge-confirmed">Potwierdzone</span>
		}
	</span>
	@if (excluded()) {
		<span class="settlement-badge settlement-badge-excluded">Wykluczone</span>
	}
</div>
@if (bonusComment()) {
	<span class="settlement-comment">{{ bonusComment() }}</span>
}
@if (excluded() || commentValue()) {
	<mat-form-field appearance="outline" class="event-comment-field" subscriptSizing="dynamic">
		<mat-label>Powód wykluczenia (opcjonalnie)</mat-label>
		<input
			matInput
			maxlength="500"
			[disabled]="disabled()"
			[ngModel]="commentValue()"
			(ngModelChange)="onCommentInput($event)"
		/>
	</mat-form-field>
}
